import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import heroImage from '../data/inicio/hero.jpg';
import ModalReserva from '../componentes/ModalReserva';
import './HeroSection.css';

const HeroSection = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="hero-section">
      <Container className="hero-text-container">
        <div className="brand-tag">ACADEMIA PIXEL</div>
        <h1>
          Domina las habilidades digitales<br />
          <span className="highlight">que el mercado demanda</span>
        </h1>
        <p className="hero-description">
          Aprende desarrollo web, IA y más con nuestro método híbrido que combina lo mejor de la
          educación presencial y virtual. Diseña tu futuro con un curso práctico y certificado de participación.
        </p>
        <div className="hero-actions">
          <button 
            className="cta-primary"
            onClick={() => setShowModal(true)}
          >
            Reservar cupo
          </button>
          <button 
            className="cta-secondary"
            onClick={() => navigate('/preguntas-frecuentes')}
          >
            ¿Preguntas? 
          </button>
        </div>
        <div className="digital-tag">
          <span>Formando creadores digitales.</span>
          <span className="digital-sub"> Un estudiante a la vez.</span>
        </div>
      </Container>
      
      <div className="hero-image-container">
        <img
          src={heroImage}
          alt="Código de programación"
          className="hero-image"
        />
        <div className="image-overlay"></div>
      </div>

      {/* Modal de Reserva */}
      {showModal && (
        <ModalReserva 
          show={showModal}
          onHide={() => setShowModal(false)}
        />
      )}
    </section>
  );
};

export default HeroSection;